<template>
  <div class="noselect">
    <!--        <div class="absBack">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        <h1 class="myTitle tablet">Impressum</h1>-->

    <v-container grid-list-md>

      <div class="text-center mt-7">
        <h4>Setup Kiosk System</h4>

        <div class="spacer-15"></div>
        <div>
          isKiosk: {{ $store.getters.isKiosk }}
        </div>
        <div>
          table: {{ $store.getters.table }}
        </div>

        <div class="mt-4">
          <v-btn color="btn-mini"
                 @click="clickBestellungen"
          >
            Letzte Bestellungen
          </v-btn>
        </div>

        <!--        <div class="pa-0">-->
        <div class="pa-0" v-if="$store.getters.isKiosk && $store.getters.isAndroidKiosk">

          <div class="superCenter">
            <div class="d-inline-block myBox">

              <KioskInputWrapper v-model="androidKioskUrl">
                <v-text-field
                  inputmode="none"
                  :input-props="{ inputmode: 'none' }"
                  v-model="androidKioskUrl"
                  label="Android Kiosk URL"
                  outlined hide-details
                ></v-text-field>
              </KioskInputWrapper>
              <div class="pt-2 pb-2" style="font-size: 0.8em; max-width: 800px">
                Geladene URL: {{ loadedUrl }}
              </div>

              <v-btn class="btn-mini"
                     @click="setAndroidKioskUrl"
              >
                Set
              </v-btn>
              <v-btn class="btn-mini ml-4"
                     @click="getAndroidKioskUrl"
              >
                Get
              </v-btn>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <h3>Ausgabeparameter</h3>
              <table class="table-collapse configTable">
                <tr>
                  <td>
                    <div>Bluetooth Devices</div>
                    <v-textarea hide-details class="outputTextarea"
                                readonly
                                inputmode="none"
                                :input-props="{ inputmode: 'none' }"
                                v-model="bluetoothDevices"
                                outlined
                                rows="3"
                                auto-grow
                                font-family="monospace"
                                persistent-hint
                    ></v-textarea>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getAndroidBluetoothDevices"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div>Softpos Verkaufstellen</div>
                    <v-textarea hide-details class="outputTextarea"
                                readonly
                                inputmode="none"
                                :input-props="{ inputmode: 'none' }"
                                v-model="allPaymentStores"
                                outlined
                                rows="3"
                                auto-grow
                                font-family="monospace"
                                persistent-hint
                    ></v-textarea>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getAndroidAllPaymentStores"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div>Softpos Terminal State</div>
                    <v-text-field
                      inputmode="none"
                      :input-props="{ inputmode: 'none' }"
                      v-model="softposTerminalState"
                      outlined hide-details
                    ></v-text-field>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getSoftposTerminalState"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div>Aktiver Store im Terminal</div>
                    <div v-if="storePicked.storeId">Name: {{ storePicked.storeName }},<br>
                      StoreID: {{ storePicked.storeId }},<br>
                      SoftpayAppId: {{ storePicked.softpayAppId }}</div>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getStorePicked"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>

              </table>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <v-container>
                <KioskInputWrapper v-model="androidJsonAppConfig">
                  <v-textarea hide-details
                              inputmode="none"
                              v-model="androidJsonAppConfig"
                              label="JSON Application Config"
                              outlined
                              rows="19"
                              auto-grow
                              clearable
                              font-family="monospace"
                              hint="Hier kannst du deine Konfiguration bearbeiten"
                              persistent-hint
                  ></v-textarea>
                </KioskInputWrapper>
              </v-container>
              <v-btn class="btn-mini"
                     @click="setAndroidJsonAppConfig"
              >
                Set
              </v-btn>
              <v-btn class="btn-mini ml-4"
                     @click="getAndroidJsonAppConfig"
              >
                Get
              </v-btn>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <v-container>
                <v-textarea hide-details
                            readonly
                            inputmode="none"
                            :input-props="{ inputmode: 'none' }"
                            v-model="printerLog"
                            label="Printer Log"
                            outlined
                            rows="8"
                            auto-grow
                            font-family="monospace"
                            persistent-hint
                ></v-textarea>
              </v-container>

              <v-btn class="btn-mini ml-4"
                     @click="getPrinterLog"
              >
                Get
              </v-btn>
            </div>
          </div>
        </div>

        <div v-if="$store.getters.isKiosk && !$store.getters.isAndroidKiosk">
          <div class="spacer-15"></div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <h3>Ausgabeparameter</h3>
              <table class="table-collapse configTable">
                <tr>
                  <td>
                    <div>Bluetooth Devices</div>
                    <v-textarea hide-details class="outputTextarea"
                                readonly
                                inputmode="none"
                                :input-props="{ inputmode: 'none' }"
                                v-model="bluetoothDevices"
                                outlined
                                rows="3"
                                auto-grow
                                font-family="monospace"
                                persistent-hint
                    ></v-textarea>
                  </td>
                  <td>
                    <v-btn class="btn-mini ml-4"
                           @click="getWindowsBluetoothDevices"
                    >
                      Get
                    </v-btn>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <v-container>
                <v-textarea hide-details
                            readonly
                            inputmode="none"
                            :input-props="{ inputmode: 'none' }"
                            v-model="printerLog"
                            label="Printer Log"
                            outlined
                            rows="8"
                            auto-grow
                            font-family="monospace"
                            persistent-hint
                ></v-textarea>
              </v-container>

              <v-btn class="btn-mini ml-4"
                     @click="getPrinterLog"
              >
                Get
              </v-btn>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <h3>Output Params:</h3>
              <div>Last Update: {{ lastUpdateOutputParams }}</div>
              <div style="white-space: pre">{{ paramsString }}</div>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <div class="flex">
                <h3>All Params:</h3>
                <v-spacer></v-spacer>
                <v-btn class="btn-mini"
                       @click="readAllParams"
                >Refresh
                </v-btn>
              </div>
              <div style="white-space: pre">{{ allParamsString }}</div>
            </div>
          </div>

          <div class="superCenter">
            <div class="d-inline-block myBox">
              <!--              <v-text-field-->
              <!--                v-model="terminalIpAddress"-->
              <!--                label="Terminal IP Address"-->
              <!--                outlined hide-details-->
              <!--              ></v-text-field>-->

              <v-text-field
                v-model="doubleValue"
                label="Betrag (inkl. Trinkgeld)"
                type="number"
                step="0.01"
                :rules="[validateDouble]"
                outlined hide-details
              ></v-text-field>

              <v-text-field
                v-model="doubleTrinkgeld"
                label="Trinkgeld (optional)"
                type="number"
                step="0.01"
                :rules="[validateDouble]"
                outlined hide-details
              ></v-text-field>

              <v-btn color="btn-df"
                     @click="triggerTerminalPayment"
              >
                Trigger Payment
              </v-btn>
            </div>
          </div>

          <v-btn color="btn-df"
                 @click="checkTerminalServiceActive"
          >
            Check Terminal Service active
          </v-btn>
          <div class="spacer-15"></div>
          <v-btn color="btn-df"
                 @click="getCurrentTerminalIp"
          >
            Get current terminal IP
          </v-btn>
          <div class="spacer-15"></div>
          <v-btn color="btn-df"
                 @click="clickTriggerDiagnose"
          >
            Trigger Diagnose
          </v-btn>

          <div class="spacer-15"></div>
          <v-btn color="btn-df"
                 @click="finishSetup"
          >
            Finish Setup and Open Start Page
          </v-btn>
        </div> <!--          eof kiosk=true-->

        <div class="spacer-20"></div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="clickDebugParams"
          >
            Öffne Konfigurationsparameter
          </v-btn>
        </div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="clickSetupShowHide"
          >
            Setup Button aus/einblenden
          </v-btn>
        </div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="releaseTerminal"
          >
            Release Terminal
          </v-btn>
        </div>
        <div class="mb-4">
          <v-btn color="btn-mini"
                 @click="dummyPrint"
          >
            Print Dummy Page
          </v-btn>
        </div>


        <div class="spacer-40"></div>
        <v-btn color="btn-mini"
               @click="exitKiosk"
        >
          Exit Kiosk Mode
        </v-btn>

      </div>


    </v-container>


    <!--    <DummyZvtDialog-->
    <!--        :total="22"-->
    <!--        :dialog="showDummyDialog"-->
    <!--        ></DummyZvtDialog>-->

  </div>
</template>

<script>

import store from "../store/store";
import {ebus} from "../vendor/ebus";
import {clearEvents, clearTheInterval, doReload, isEmptyObject} from "../vendor/util";
// import DummyZvtDialog from "../dialogs/DummyZvtDialog.vue";
import ZvtDialog from "../dialogs/ZvtDialog.vue";
import KioskInputWrapper from "./KioskInputWrapper.vue";

export default {
  components: {KioskInputWrapper, ZvtDialog},
  data: () => ({
    iv1: null,
    doubleValue: null,
    doubleTrinkgeld: null,
    params: null,
    allParams: null,
    lastUpdateOutputParams: 0,

    androidKioskUrl: '',
    loadedUrl: window.location.href,
    // softposStoreName: '',
    androidJsonAppConfig: '',
    bluetoothDevices: '',
    allPaymentStores: '',
    printerLog: '',

    showDummyDialog: false,
  }),

  created() {
    ebus.$on('cb-postToWindowskiosk', (resp) => {
      console.log('receive callback from cb-postToWindowskiosk');
      if (resp && !isEmptyObject(resp)) {
        const responseAction = '' + resp.action;
        delete resp.action;

        if (responseAction === 'triggerPosTerminal') {
          ebus.$emit('showInfo', {
            title: 'trigger response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        } else if (responseAction === 'readStatusFromTerminal') {
          this.handleZvtStatusResponse(resp);
        } else if (responseAction === 'readErgebnisFromTerminal') {
          this.params = resp;
        } else if (responseAction === 'readAllParams') {
          this.allParams = resp;
        } else if (responseAction === 'checkTerminalServiceActive') {
          if (!(resp.ok && resp.configSetupCompleted)) {
            ebus.$emit('showInfo', {
              title: 'WARNING: The device setup is incomplete. Please contact the administrator',
              text: 'Setup check response: ' + JSON.stringify(resp),
            });
          } else {
            ebus.$emit('showInfo', {
              title: 'Setup check response: ' + JSON.stringify(resp),
              // text: 'Vielen Dank!'
            });
          }
        } else if (responseAction === 'getCurrentTerminalIp') {
          ebus.$emit('showInfo', {
            title: 'response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        } else if (responseAction === 'triggerDiagnose') {
          ebus.$emit('showInfo', {
            title: 'diagnose response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        } else if (responseAction === 'dummyPrint') {
          ebus.$emit('showInfo', {
            title: 'dummyPrint response: ' + JSON.stringify(resp, null, 2),
            // text: 'Vielen Dank!'
          });
        } else if (responseAction === 'getPrinterLog') {
          if (resp?.printerLog?.length) {
            store.commit('printerLog', '' + resp.printerLog);
          }
        } else if (responseAction === 'getBluetoothDevices') {
          if (resp?.devices?.length) {
            store.commit('bluetoothDevices', '' + JSON.stringify(resp.devices, null, 2));
          } else {
            store.commit('bluetoothDevices', '[]');
          }
        }
      }
    });

  },

  mounted() {
    if (store.getters.isKiosk && !store.getters.isAndroidKiosk) {
      this.initIv();
    }
    if (store.getters.isKiosk && store.getters.isAndroidKiosk) {
      this.getAndroidKioskUrl();
      this.getAndroidJsonAppConfig();
    }
    store.commit('showLoading', false);
  },

  destroyed() {
    clearEvents([
      'cb-postToWindowskiosk',
    ]);
    clearInterval(this.iv1);
  },

  computed: {
    storePicked() {
      return store.getters.storePicked;
    },

    softposTerminalState() {
      return store.getters.softposTerminalState;
    },

    paramsString() {
      if (!this.params) {
        return "loading...";
      }
      return JSON.stringify(this.params, null, 2);
    },

    allParamsString() {
      if (!this.allParams) {
        return "";
      }
      return JSON.stringify(this.allParams, null, 2);
    },

  },

  methods: {
    getAndroidJsonAppConfig() {
      ebus.$emit('getAndroidJsonAppConfig');
      setTimeout(() => {
        console.log('getAndroidJsonAppConfig  2/2: update UI ' + store.getters.androidJsonAppConfig);
        this.androidJsonAppConfig = '' + store.getters.androidJsonAppConfig;
      }, 300);
    },
    setAndroidJsonAppConfig() {
      if (this.androidJsonAppConfig?.length) {
        ebus.$emit('setAndroidJsonAppConfig', '' + this.androidJsonAppConfig);
      }
    },

    // getSoftposStoreName() {
    //   ebus.$emit('getSoftposStoreName');
    //   setTimeout(() => {
    //     console.log('getSoftposStoreName  2/2: update UI ' + store.getters.softposStoreName);
    //     this.softposStoreName = '' + store.getters.softposStoreName;
    //   }, 300);
    // },
    // setSoftposStoreName() {
    //   if (this.softposStoreName?.length) {
    //     ebus.$emit('setSoftposStoreName', '' + this.softposStoreName);
    //   }
    // },

    getWindowsBluetoothDevices() {
      ebus.$emit('getWindowsBluetoothDevices');
      ebus.$emit('postToWindowskiosk', {
        action: 'getBluetoothDevices',
        cb: 'cb-postToWindowskiosk'
      });
      setTimeout(() => {
        console.log('getBluetoothDevices 2/2: update UI ' + store.getters.bluetoothDevices);
        this.bluetoothDevices = '' + store.getters.bluetoothDevices;
      }, 5000);
    },

    getAndroidBluetoothDevices() {
      ebus.$emit('getAndroidBluetoothDevices');
      setTimeout(() => {
        console.log('getAndroidBluetoothDevices 2/2: update UI to bluetoothDevices ' + store.getters.bluetoothDevices);
        this.bluetoothDevices = '' + store.getters.bluetoothDevices;
      }, 300);
    },

    getAndroidAllPaymentStores() {
      ebus.$emit('getAndroidAllPaymentStores');
      setTimeout(() => {
        console.log('getAndroidAllPaymentStores 2/2: update UI to allPaymentStores ' + store.getters.bluetoothDevices);
        this.allPaymentStores = '' + store.getters.allPaymentStores;
      }, 2000);
    },

    getSoftposTerminalState() {
      ebus.$emit('getSoftposTerminalState');
    },

    getStorePicked() {
      ebus.$emit('getStorePicked');
    },

    getPrinterLog() {
      ebus.$emit('postToWindowskiosk', {
        action: 'getPrinterLog',
        cb: 'cb-postToWindowskiosk'
      });
      setTimeout(() => {
        console.log('getPrinterLog 2/2: update UI ' + store.getters.printerLog);
        this.printerLog = '' + store.getters.printerLog;
      }, 300);
    },

    getAndroidKioskUrl() {
      ebus.$emit('getKioskUrl');
      setTimeout(() => {
        console.log('getAndroidKioskUrl 2/2: update UI ' + store.getters.androidKioskUrl);
        this.androidKioskUrl = '' + store.getters.androidKioskUrl;
      }, 300);
    },
    setAndroidKioskUrl() {
      if (this.androidKioskUrl?.length) {
        ebus.$emit('saveKioskUrl', '' + this.androidKioskUrl);
      }
    },

    releaseTerminal() {
      ebus.$emit('releaseTerminal');
      ebus.$emit('showInfo', {
        title: 'Terminal Release wurde durchgeführt',
        // text: 'Vielen Dank!'
      });
    },

    dummyPrint() {
      if (store.getters.isAndroidKiosk) {
        ebus.$emit('postToWindowskiosk', {
          action: 'dummyPrint',
          cb: 'cb-androidDummyPrint'
        });
      } else {
        ebus.$emit('postToWindowskiosk', {
          action: 'dummyPrint',
          cb: 'cb-dummyPrint'
        });
      }
    },

    clickSetupShowHide() {
      store.commit('hideSetupButton', !store.getters.hideSetupButton);
    },

    clickDebugParams() {
      ebus.$emit('goto', {name: 'debugParams'});
    },

    initIv() {
      if (this.iv1) {
        clearTheInterval(this.iv1);
      }

      this.iv1 = setInterval(() => {
        this.lastUpdateOutputParams = Date.now();
        this.readErgebnisFromTerminal();
      }, 15 * 1000);
    },

    validateDouble(value) {
      if (value === null || value === '') return true;
      return !isNaN(value) && !isNaN(parseFloat(value)) || 'Must be a valid number';
    },

    getCurrentTerminalIp() {
      ebus.$emit('postToWindowskiosk', {
        action: 'getCurrentTerminalIp',
        cb: 'cb-postToWindowskiosk'
      });
    },

    clickTriggerDiagnose() {
      ebus.$emit('postToWindowskiosk', {
        action: 'triggerDiagnose',
        cb: 'cb-postToWindowskiosk',
        timeout: 20 * 1000,
      });
    },

    readAllParams() {
      this.allParams = null;
      ebus.$emit('postToWindowskiosk', {
        action: 'readAllParams',
        cb: 'cb-postToWindowskiosk'
      });
    },

    readErgebnisFromTerminal() {
      ebus.$emit('postToWindowskiosk', {
        action: 'readErgebnisFromTerminal',
        //terminalId: '' + store.getters.table,
        cb: 'cb-postToWindowskiosk'
      });
    },

    triggerTerminalPayment() {
      console.log('testTriggerPosTerminal clicked');
      if (!store.getters.isKiosk) {
        return;
      }

      console.log('emit postToWindowskiosk');
      ebus.$emit('postToWindowskiosk', {
        action: 'triggerPosTerminal',
        uniqueOrderId: 'test-uniqueOrderId',
        betrag: 0 + this.doubleValue,
        trinkgeld: this.doubleTrinkgeld ? this.doubleTrinkgeld : 0,
        cb: 'cb-postToWindowskiosk'
      });

    },

    clickBestellungen() {
      this.$router.replace({name: 'Bestellungen'});
    },

    checkTerminalServiceActive() {
      console.log('checkTerminalServiceActive clicked');
      if (!store.getters.isKiosk) {
        return;
      }

      console.log('emit postToWindowskiosk');
      ebus.$emit('postToWindowskiosk', {
        action: 'checkTerminalServiceActive',
        cb: 'cb-postToWindowskiosk'
      });

    },

    finishSetup() {
      this.$router.replace({name: 'Home'});
    },

    exitKiosk() {
      this.$ls.remove('kioskTable');
      store.commit('setIsKiosk', false);
      store.commit('setShowKioskSplashOnHome', false);
      store.commit('setEnableOrderModeSelection', false);
      store.commit('setEnableOrderModeSelectionWithTime', false);
      ebus.$emit('clearInhouseModus', {eventSource: 'exitKiosk'});
      this.$ls.remove('kioskTable');
      //   doReload('exitKiosk');

      //reload is required to load the default parameters again
      setTimeout(() => {
        doReload('exitKiosk');
      }, 500);

      this.$router.replace({name: 'Home'});
    },


  }
}
</script>

<style scoped lang="scss">
@import '../styles/base';

.outputTextarea {
  min-width: 350px;
}

.configTable {
  td {
    padding: 2px 0;
  }
}

.myBox {
  padding: 30px;
  margin: 20px;
  border: 2px solid black;;
  border-radius: $box-border-radius;
  background-color: white;
  min-width: 600px;
  max-width: 1000px;
  overflow-x: hidden;
}
</style>
